var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"accounts-tab"},[_c('AccountsTable',{attrs:{"corp-id":_vm.corp.id,"corp-name":_vm.corp.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }